<template>
  <div>
    <v-card-title class="body-2 v-card__subtitle">
      <v-icon small class="mr-2">mdi-chart-line</v-icon>
      Verlauf (Letzte Berechnungen)
    </v-card-title>
    <v-card-text v-if="!loading && hasData">
      <VueApexCharts
        type="line"
        :options="chartOptions"
        :series="chartSeries"
        :height="height"
      ></VueApexCharts>
    </v-card-text>
    <v-card-text
      v-else-if="loading"
      class="d-flex justify-center align-center"
      :style="{ height: height + 'px' }"
    >
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-card-text>
    <v-card-text
      v-else
      class="d-flex justify-center align-center"
      :style="{ height: height + 'px' }"
    >
      <div class="text-center grey--text">
        <v-icon large color="grey">mdi-chart-line</v-icon>
        <div class="mt-2">Keine Daten verfügbar</div>
      </div>
    </v-card-text>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import apexChartsDarkMode from "@/mixins/apexChartsDarkMode";

export default {
  name: "TrendChart",
  mixins: [apexChartsDarkMode],
  components: {
    VueApexCharts,
  },
  props: {
    summaryData: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
      default: 280,
    },
  },
  computed: {
    hasData() {
      return this.summaryData && this.summaryData.length > 0;
    },
    sortedSummaries() {
      if (!this.hasData) return [];
      return [...this.summaryData].sort((a, b) => a.date.localeCompare(b.date));
    },
    chartSeries() {
      if (!this.hasData) return [];

      const greenData = [];
      const yellowData = [];
      const redData = [];

      this.sortedSummaries.forEach((summary) => {
        const total = summary.totalCount || 1;
        const trafficLightCounts = summary.trafficLightStatusCounts || {};

        const green = trafficLightCounts.green || 0;
        const yellow = trafficLightCounts.yellow || 0;
        const red = trafficLightCounts.red || 0;

        const greenPercent = Math.round((green / total) * 100);
        const yellowPercent = Math.round((yellow / total) * 100);
        const redPercent = Math.round((red / total) * 100);

        greenData.push(greenPercent);
        yellowData.push(yellowPercent);
        redData.push(redPercent);
      });

      return [
        {
          name: "Grün",
          data: greenData,
        },
        {
          name: "Gelb",
          data: yellowData,
        },
        {
          name: "Rot",
          data: redData,
        },
      ];
    },
    chartOptions() {
      if (!this.hasData) return {};

      const categories = this.sortedSummaries.map((summary) => {
        const [, month, day] = summary.date.split("-");
        return `${day}.${month}`;
      });

      return {
        ...this.apexChartsDarkModeOptions,
        chart: {
          ...this.apexChartsDarkModeOptions.chart,
          type: "line",
          toolbar: {
            show: false,
          },
        },
        colors: ["#4CAF50", "#FF9800", "#F44336"],
        stroke: {
          curve: "smooth",
          width: 3,
        },
        xaxis: {
          categories: categories,
          labels: {
            rotate: -45,
            rotateAlways: categories.length > 10,
            style: {
              fontSize: "11px",
            },
          },
        },
        yaxis: {
          max: 100,
          labels: {
            formatter: function (val) {
              return val + "%";
            },
          },
          title: {
            text: "Prozentsatz (%)",
          },
        },
        legend: {
          position: "top",
        },
        markers: {
          size: 4,
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: function (val) {
              return val + "%";
            },
          },
        },
      };
    },
  },
};
</script>
